export const PAYMENTS = {
    OVERVIEW_RECORDS: 250,
    AMOUNT_MIN_RANGE: 0,
    AMOUNT_MAX_RANGE: 100000
}

export const PAYMENT_TYPE = {
    international: 'international',
    domestic: 'domestic',
    internal: 'internal',
    domesticuk: 'domesticuk-payments'
}

export const PAYMENT_BENF_SORT_VALUE = [
    { value: "Most recently used beneficiaries" },
    { value: "Beneficiary name" }
]

export const ICON_STYLE = {
    width: 26,
    height: 26,
  }
  
export const FILTER_ICON_STYLE = {
    WIDTH: 28,
    HEIGHT: 21
}

export const PAYMENT_RANGE_TODAY = 'today';
export const PAYMENT_RANGE_ONE_WEEK = 'oneWeek';
export const PAYMENT_RANGE_ONE_MONTH = 'oneMonth';
export const PAYMENT_RANGE_RANGE = 'range';

export const PAYMENT_RANGE_OPTIONS = [
  PAYMENT_RANGE_TODAY,
  PAYMENT_RANGE_ONE_WEEK,
  PAYMENT_RANGE_ONE_MONTH,
  PAYMENT_RANGE_RANGE
];

export const POPOVER_ICON_SIZE = {
  WIDTH: 30,
  HEIGHT: 30
}

export const VOP_VALIDATE_CODES = {
    FULL_MATCH: 'MTCH',
    CLOSED_MATCH: 'CMTC',
    NO_MATCH: 'NMTC',
    VER_FAILED: 'NOAP',
}  
